import { DateTime as DT } from 'luxon';

export const DOCUMENT_TEMPLATE_KEYS = ['docNumber', 'docDate'] as const;

export type DocumentTemplateKey = (typeof DOCUMENT_TEMPLATE_KEYS)[number];

export interface BuildDocumentTemplateValueKeysParams {
    proposalNumber?: string | null;
    proposalDt?: number | null;
}

const escapeHtml = (value: string): string =>
    value
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');

const formatDocDate = (raw: unknown): string => {
    const millis = Number(raw || 0);
    if (!Number.isFinite(millis) || millis <= 0) return '';
    return DT.fromMillis(millis).toFormat('dd.MM.yyyy');
};

/** Builds replaceable template keys from document number/date form fields. */
export const buildDocumentTemplateValueKeysMap = ({
    proposalNumber,
    proposalDt,
}: BuildDocumentTemplateValueKeysParams): Record<string, string> => ({
    docNumber: escapeHtml(String(proposalNumber || '').trim()),
    docDate: formatDocDate(proposalDt),
});
